const STORAGE_KEY = "satyam-recent-airports";
const MAX_RECENTS = 6;

export function sameAirport(a, b) {
  return a?.cityCode === b?.cityCode && a?.airportName === b?.airportName;
}

export function airportCityCode(airport) {
  return String(airport?.cityCode || "").trim().toUpperCase();
}

export function excludeAirportsByCityCode(airports, excludeCityCode) {
  const excluded = String(excludeCityCode || "").trim().toUpperCase();
  const list = Array.isArray(airports) ? airports : [];
  if (!excluded) return list;
  return list.filter((item) => airportCityCode(item) !== excluded);
}

export function getRecentAirports() {
  try {
    const parsed = JSON.parse(localStorage.getItem(STORAGE_KEY) || "[]");
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
}

export function addRecentAirport(airport) {
  if (!airport?.cityCode) {
    return getRecentAirports();
  }

  const next = [
    airport,
    ...getRecentAirports().filter((item) => !sameAirport(item, airport)),
  ].slice(0, MAX_RECENTS);

  localStorage.setItem(STORAGE_KEY, JSON.stringify(next));
  return next;
}

export function clearRecentAirports() {
  localStorage.removeItem(STORAGE_KEY);
  return [];
}
